import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-faad5714")

_pushScopeId("data-v-faad5714")
const _hoisted_1 = { class: "base-individual-card" }
const _hoisted_2 = { class: "base-individual-card__content" }
const _hoisted_3 = {
  key: 0,
  class: "base-individual-card__price"
}
const _hoisted_4 = {
  key: 1,
  class: "base-individual-card__price"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "base-individual-card__header",
      style: { backgroundColor: _ctx.color }
    }, null, 4),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "base-individual-card__title",
        style: _ctx.title.length > 10 && { fontSize: '1.5em' }
      }, _toDisplayString(_ctx.title), 5),
      (_ctx.owner && _ctx.owner.name)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('boardCard.pay')) + " " + _toDisplayString(_ctx.charge), 1))
        : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('boardCard.buy')) + " " + _toDisplayString(_ctx.price), 1)),
      _createVNode("div", {
        class: ["base-individual-card__owner", { owned: _ctx.owner && _ctx.owner.name }]
      }, _toDisplayString(_ctx.owner && _ctx.owner.name ? _ctx.owner.name : _ctx.$t('boardCard.notOwned')), 3)
    ])
  ]))
})